import './index.scss'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useRef, useState } from 'react'
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const refForm = useRef(null);
    const inputElement = useRef(null);
    const successNotify = () => toast.success('Message Sent Successfully! Thanks!', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        });
      const errorNotify = () => toast.error('Message Failed To Send, Please Try Again', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          });

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 3000)
      }, [])

      const sendEmail = (e) => {
        e.preventDefault()
        

        emailjs
            .sendForm(
                'service_k3dbnrh',
                'template_j6936rd',
                refForm.current,
                '3yIOHpD_e5TjCQOJm'
            )
            .then(function(response) {
                successNotify()
             }, function(err) {
                errorNotify()
             });
      }

      function onFocusHandler(){
        document.body.style.overflowY = 'scroll';
    }
    
    function onBlurHandler(){
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        const setProperty = setTimeout(() => {
            document.body.style.overflowY = 'hidden';
        }, 500)
        return () => clearTimeout(setProperty)
      }

    return (
    <>
     <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark"/>
        <div className='container contact-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetters 
                        letterClass={letterClass}
                        strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
                        idx={15}
                    />
                </h1>
                <p>
                I have a strong interest in securing a full-time position. However, I am also open to freelance opportunities and exploring new ventures that align with my skills and passions. I am eager to discuss any potential projects or positions that may be a good fit. Let's connect and explore the possibilities!
                </p>
                <div className='contact-form'>
                    <form onFocus={onFocusHandler}  onBlur={onBlurHandler} ref={refForm} onSubmit={sendEmail}>
                        <ul>
                            <li className='half'>
                                <input type='text' name='name' placeholder='Name' required />
                            </li>
                            <li className='half'>
                                <input type='text' name='email' placeholder='Email' required />
                            </li>
                            <li>
                                <input type='text' name='subject' placeholder='Subject' required />
                            </li>
                            <li>
                                <textarea placeholder='Message' name='message' required></textarea>
                            </li>
                            <li>
                                <input type='submit' className='flat-button' value='SEND'/>
                            </li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
        <Loader type='pacman'/>
    </>
    )
}

export default Contact